import BadgeIcon from '../../../components/icons/BadgeIcon';
import ClockIcon from '../../../components/icons/ClockIcon';
import {
  ChallengeIconsRow,
  PointsContainer,
  TimeContainer,
  Text,
  LocationContainer,
} from '../components';
import theme from 'utils/theme';
import useLocationIconText from '../../../hooks/useLocationIconText';
import localizedStrings from 'localization/en';

type ChallengeBasicInformationProps = {
  xp: number;
  time: number;
  small?: boolean;
  location: string;
  bonusChallenge?: boolean;
};

const ChallengeBasicInformation = ({
  xp = 0,
  time = 0,
  small = false,
  location,
  bonusChallenge,
}: ChallengeBasicInformationProps) => {
  const [Icon, text] = useLocationIconText(location);

  return (
    <ChallengeIconsRow>
      <LocationContainer>
        <Icon
          width={theme.typography.large32}
          height={theme.typography.large32}
          color={theme.colors.white[100]}
        />
        <Text>{text === localizedStrings.phoneRecommended ? '' : text}</Text>
      </LocationContainer>
      <PointsContainer>
        <BadgeIcon width={theme.typography.large32} height={theme.typography.large32} />
        <Text small={small}>{`${xp}${localizedStrings.experience(
          bonusChallenge,
        )}`}</Text>
      </PointsContainer>
      <TimeContainer>
        <ClockIcon width={theme.typography.large32} height={theme.typography.large32} />
        <Text small={small}>{time} min</Text>
      </TimeContainer>
    </ChallengeIconsRow>
  );
};

export default ChallengeBasicInformation;
